import hintMessage from '@/components/form/partials/hint-message.vue';
import errorMessage from '@/components/form/partials/error-message.vue';

export default {
  components: {
    'hint-message': hintMessage,
    'error-messages': errorMessage,
  },
  props: {
    hint: {
      default: null,
      type: Object,
    },
    error: {
      default() {
        return {
          status: '',
          message: '',
        };
      },
      type: Object,
    },
  },
};
